<template>
    <v-container>
		<div>
			<s-crud
				:config="config"
				edit
				remove
				search-input
				title="Presupuesto Ágil"
                ref="BudgetAgileCrud"
				@save="save($event)"
				height="auto"
			>
            <template v-slot:options>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text small @click="MassiveModal = true">
                            <v-icon left>mdi-file-excel</v-icon>
                        </v-btn>
                    </template>
                    <span>Importar Presupuesto desde Excel</span>
                </v-tooltip>
            </template>

            <template scope="props">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="3"><s-text label="Condición" v-model="props.item.BgtCondition" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Cod CC" v-model="props.item.BgtCodeCC" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Centro Costo" v-model="props.item.BgtCostCenter" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Cod. Cuenta" v-model="props.item.BgtAccountCode" /></v-col>
                        
                        <v-col cols="12" md="3"><s-text label="Denominación" v-model="props.item.BgtDenomination" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Grupo Cuentas" v-model="props.item.BgtAccountGroup" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Cuenta CECO" v-model="props.item.BgtAccountCeco" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Gerente Enviado" v-model="props.item.BgtManagerSent" /></v-col>

                        <v-col cols="12" md="3"><s-text label="Responsable Enviado" v-model="props.item.BgtResponsibleSent" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Gerente Responsable" v-model="props.item.BgtManagerResponsible" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Responsable" v-model="props.item.BgtResponsible" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Gerencia Usuaria" v-model="props.item.BgtUserManagement" /></v-col>

                        <v-col cols="12" md="3"><s-text label="Area" v-model="props.item.BgtArea" /></v-col>
                        <v-col cols="12" md="3"><s-text label="COD 2D" v-model="props.item.BgtCode2D" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Tipo Gasto" v-model="props.item.BgtExpenseType" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Cod Linea Negocio" v-model="props.item.BgtBusinessLineCode" /></v-col>

                        <v-col cols="12" md="3"><s-text label="Linea Negocio" v-model="props.item.BgtBusinessLine" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Cod Tipo Costo" v-model="props.item.BgtCostTypeCode" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Cod Tipo Costo 2" v-model="props.item.BgtCostTypeCode2" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Cod Material/Servicio" v-model="props.item.BgtMaterialServiceCode" /></v-col>

                        <v-col cols="12" md="3"><s-text label="Desc. Material/Servicio" v-model="props.item.BgtMaterialServiceDescription" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Glosa" v-model="props.item.BgtGloss" /></v-col>
                        <v-col cols="12" md="2"><s-text label="Año" v-model="props.item.BgtYear" /></v-col>
                        <v-col cols="12" md="2"><s-text label="Mes" v-model="props.item.BgtMonth" /></v-col>

                        <v-col cols="12" md="2"><s-text label="Cantidad" v-model="props.item.BgtQuantity" /></v-col>
                        <v-col cols="12" md="2"><s-text label="UM" v-model="props.item.BgtUnitMeasure" /></v-col>
                        <v-col cols="12" md="2"><s-text label="PU" v-model="props.item.BgtUnitPrice" /></v-col>
                        <v-col cols="12" md="2"><s-text label="Moneda Origen" v-model="props.item.BgtOriginCurrency" /></v-col>

                        <v-col cols="12" md="3"><s-text label="Total Moneda Origen" v-model="props.item.BgtTotalOriginCurrency" /></v-col>
                        <v-col cols="12" md="2"><s-text label="TC" v-model="props.item.BgtExchangeRate" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Total USD" v-model="props.item.BgtTotalUSD" /></v-col>
                        <v-col cols="12" md="3"><s-text label="Total PEN" v-model="props.item.BgtTotalPEN" /></v-col>
                    </v-row>
                </v-container>
            </template>

            </s-crud>
            
            <BudgetAgileImportModal
                :isOpen.sync="MassiveModal"
                @close="MassiveModal = false"
                @saved="load()"
            />
        </div>
    </v-container>
</template>

<script>

import _sBudgetAgileService from "@/services/Accounting/BudgetAgileService";
import BudgetAgileImportModal from "./BudgetAgileImportModal.vue";

export default {
  name: "",
  components: {
      BudgetAgileImportModal
  },
  props: {},
  data: () => ({
    filter: {},
    config: {
      model: {
        BgtID: "ID",
      },
      service: _sBudgetAgileService,
      headers: [
        { text: "ID", value: "BgtID", sortable: false, width: 60 },
        { text: "Condicion", value: "BgtCondition", sortable: false, width: 120 },
        { text: "Cod CC", value: "BgtCodeCC", sortable: false, width: 100 },
        { text: "Centro Costo", value: "BgtCostCenter", sortable: false, width: 100 },
        { text: "Cod. Cuenta", value: "BgtAccountCode", sortable: false, width: 100 },
        { text: "Denominacion", value: "BgtDenomination", sortable: false, width: 200 },
        { text: "Grupo Cuentas", value: "BgtAccountGroup", sortable: false, width: 150 },
        { text: "Cuenta CECO", value: "BgtAccountCeco", sortable: false, width: 100 },
        { text: "Gerente Env.", value: "BgtManagerSent", sortable: false, width: 150 },
        { text: "Resp. Env.", value: "BgtResponsibleSent", sortable: false, width: 150 },
        { text: "Gerente Resp.", value: "BgtManagerResponsible", sortable: false, width: 150 },
        { text: "Responsable", value: "BgtResponsible", sortable: false, width: 150 },
        { text: "Gerencia Usu.", value: "BgtUserManagement", sortable: false, width: 150 },
        { text: "Area", value: "BgtArea", sortable: false, width: 150 },
        { text: "COD 2D", value: "BgtCode2D", sortable: false, width: 100 },
        { text: "Tipo Gasto", value: "BgtExpenseType", sortable: false, width: 120 },
        { text: "Cod Linea Neg.", value: "BgtBusinessLineCode", sortable: false, width: 100 },
        { text: "Linea Negocio", value: "BgtBusinessLine", sortable: false, width: 150 },
        { text: "Cod Tipo Costo", value: "BgtCostTypeCode", sortable: false, width: 100 },
        { text: "Cod Tipo Costo 2", value: "BgtCostTypeCode2", sortable: false, width: 100 },
        { text: "Cod Mat/Serv", value: "BgtMaterialServiceCode", sortable: false, width: 120 },
        { text: "Desc. Mat/Serv", value: "BgtMaterialServiceDescription", sortable: false, width: 200 },
        { text: "Glosa", value: "BgtGloss", sortable: false, width: 200 },
        { text: "Año", value: "BgtYear", sortable: false, width: 80 },
        { text: "Mes", value: "BgtMonth", sortable: false, width: 80 },
        { text: "Cant.", value: "BgtQuantity", sortable: false, width: 80 },
        { text: "UM", value: "BgtUnitMeasure", sortable: false, width: 80 },
        { text: "PU", value: "BgtUnitPrice", sortable: false, width: 100 },
        { text: "Moneda", value: "BgtOriginCurrency", sortable: false, width: 80 },
        { text: "Total Moneda", value: "BgtTotalOriginCurrency", sortable: false, width: 120 },
        { text: "TC", value: "BgtExchangeRate", sortable: false, width: 80 },
        { text: "Total USD", value: "BgtTotalUSD", sortable: false, width: 120 },
        { text: "Total PEN", value: "BgtTotalPEN", sortable: false, width: 120 },
      ],
    },
    MassiveModal: false,
  }),
  methods: {
    load(){
        this.$refs.BudgetAgileCrud.refresh();
    },
    save(item){
        item.save();
    }
  }
};
</script>